import { ReactNode } from "react";

import styles from "./Card.module.scss";

type CardProps = {
  children: ReactNode;
  title?: string;
  button?: ReactNode;
};

const Card = ({ children, title, button }: CardProps) => {
  return (
    <div className={styles.card}>
      {title && (
        <div className={styles.cardHeader}>
          <h3 className={styles.cardTitle}>{title}</h3>
          {button}
        </div>
      )}
      {children}
    </div>
  );
};
export default Card;
